import { Box } from "@mui/material";
import type { Icon } from "@phosphor-icons/react";
import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  TiktokLogo,
  XLogo,
  YoutubeLogo,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const networks: [string, string, Icon][] = [
  ["Linkedin", "https://fr.linkedin.com/company/the-gifts-club", LinkedinLogo],
  ["Youtube", "https://www.youtube.com/channel/UCPW8Fug5cOWVHVXWd0YX10Q", YoutubeLogo],
  ["Instagram", "https://www.instagram.com/thegiftsclub.io", InstagramLogo],
  ["Facebook", "https://www.facebook.com/TheGiftsClub", FacebookLogo],
  ["Tiktok", "https://www.tiktok.com/@thegiftsclub", TiktokLogo],
  ["Twitter", "https://x.com/the_gifts_club", XLogo],
];

export default function SidenavNetworks() {
  return (
    <Box p={2} position="relative">
      <img src={"/sidenav/follow-us.svg"} alt="Follow_us" />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          position: "absolute",
          bottom: "22%",
          left: 5,
          right: 5,
          mx: "5%",
        }}
      >
        {networks.map(([name, link, Icon]) => (
          <Box
            key={name}
            component={Link}
            to={link}
            target="_blank"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: "primary.light",
            }}
            children={<Icon size="24px" color="black" aria-label={name} />}
          />
        ))}
      </Box>
    </Box>
  );
}
